/* eslint-disable camelcase */
const jargonData = require('../../config').jargon;

const validateProperty = (entry, property, key) => {
  const value = entry[property];
  if (typeof value === 'undefined' || value === null || value.length === 0) {
    throw new Error(`Property '${property}' is not defined for jargon entry '${key}'!`);
  }
};

const getJargon = () => {
  const jargon = {};
  for (const key in jargonData) {
    const entry = jargonData[key];
    validateProperty(entry, 'name', key);
    validateProperty(entry, 'description', key);
    let long_description = `<span><b>${entry.name}</b>`;

    const { long_name } = entry;
    if (typeof long_name !== 'undefined' && long_name !== null && long_name.length > 0) {
      long_description += ` - ${long_name}`;
    }
    long_description += `</span> ${entry.description}`;
    jargon[key] = long_description;
  }

  return jargon;
};

const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

const arraysEqual = (a, b) => {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;

  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

const flatten = (arr) =>
  arr.map(({ node: { frontmatter, fields, ...rest } }) => ({
    ...frontmatter,
    ...fields,
    ...rest
  }));

module.exports = { sleep, arraysEqual, flatten, getJargon };
